import getElementTop from "../../util/get-element-top";

function LoadMore()
{
    console.log('LoadMore component initialized');

    // const loadMoreButton = document.querySelector('.btn-loadmore');

    const postsRow = document.getElementById('postsRow');
    const loadMorePostsButton = document.getElementById('loadMorePostsButton');
    const buttonText = (loadMorePostsButton !== null) ? loadMorePostsButton.innerText : null;
    const parser = new DOMParser();

    console.log('loadMorePostsButton', loadMorePostsButton);


    if (loadMorePostsButton === null) {
        return;
    }

    // loadMoreButton.addEventListener('click', event => {
    //     event.preventDefault();

    // });

    // var loadMorePostsParamsObj = {
    //     action: 'loadmore_posts',
    //     page: 2
    // };

    // Define fetch function to retrieve products
    // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
    // https://developer.mozilla.org/en-US/docs/Web/API/fetch
    async function loadPosts(url = '', data = {}) {
        // if (loadMorePostsParamsObj.page === 1) {
        //     postsList.innerHTML = "";
        // }

        console.log('loadPosts');

        // Default options are marked with *
        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'same-origin', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            //credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json'
                //'Accept': 'text/html'
            },
            //redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: data
        });

        //return await response.text();

        return await response.json(); // parses JSON response into native JavaScript objects
    }


    // Load More Posts button
    if (loadMorePostsButton !== null) {
        // loadMorePostsButton.taxonomy = loadMorePostsButton.dataset.taxonomy;
        // loadMorePostsButton.category_id = parseInt(loadMorePostsButton.dataset.categoryId);
        loadMorePostsButton.addEventListener("click", doLoadPosts);
    }


    function doLoadPosts(event) {
        event.preventDefault();

        console.log('doLoadPosts');

        // if (postsListWrapper !== null) {
        //     postsListWrapper.classList.add('bf-loading');
        // }

        loadMorePostsButton.classList.add('is-loading');

        //loadMorePostsButton.innerHTML = '<span class="loadmore-spinner spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> Loading...';
        loadMorePostsButton.disabled = true;

        let qs = '';
        let base = loadMorePostsButton.dataset.base;
        const pos = base.indexOf('?');
        
        console.log('base', base);
        console.log('pos', pos);

        if (pos > 0) {
            qs = base.substring(pos);
            base = base.substring(0, pos);
        }

        const urlParamsObj = {
            action: 'loadmore',
            query: bf_opts.posts,
            page: bf_opts.current_page,
            is_search: bf_opts.is_search
        };

        const urlParams = new URLSearchParams(urlParamsObj);
        
        console.log('urlParams.toString()', decodeURIComponent(urlParams.toString()));

        // let dataParamString = jQuery.param(loadMorePostsParamsObj);

        // Fetch the results
        loadPosts(bf_opts.ajaxurl, urlParams)
        .then((response) => {
            console.log('response', response);
            history.pushState('data', '', loadMorePostsButton.getAttribute('href'));

            loadMorePostsButton.innerText = buttonText;

            //var scroll = jQuery(window).scrollTop();

            const postItems = postsRow.querySelectorAll('.post-item');
            const lastPost = postItems[postItems.length - 1];

            // const resultHtml = document.createElement('div');

            // jQuery('.post-item:last').after(result);

            // jQuery(window).scrollTop(scroll);

	        const htmlResponse = parser.parseFromString(response.data.html, 'text/html');
            const items = htmlResponse.querySelectorAll('body > .post-item');
            const fragment = new DocumentFragment();
            items.forEach(item => {
                fragment.append(item)
            });

            lastPost.after(fragment);

            const postsTop = getElementTop(lastPost.nextElementSibling);
            if (postsTop !== false) {
                window.scrollTo({
                    top: postsTop,
                    behavior: 'smooth'
                });
            }

            bf_opts.current_page++;
            
            // btn.prop('href', base + 'page/' + (bf_opts.current_page + 1) + '/' + qs);

            loadMorePostsButton.setAttribute('href', base + 'page/' + (bf_opts.current_page + 1) + '/' + qs);

            if (bf_opts.current_page >= bf_opts.max_page) {
                loadMorePostsButton.remove();
            }

            //postsListWrapper.classList.remove('bf-loading');
            //postsList.innerHTML += response.data.html;

            // if (response.data.currentPage >= response.data.maxNumPages) {
            //     loadMorePostsParamsObj.page = response.data.currentPage;
            //     loadMorePostsButton.classList.add('d-none');
            // } else {
            //     loadMorePostsParamsObj.page = response.data.currentPage + 1;
            //     loadMorePostsButton.classList.remove('d-none');
            // }
        })
        .finally(() => {
            loadMorePostsButton.classList.remove('is-loading');
            loadMorePostsButton.disabled = false;
        })
        .catch((error) => {
            console.error('Error loading posts:', error);
            //postsListWrapper.classList.remove('bf-loading');
            // loadMorePostsButton.innerHTML = buttonText;
            // loadMorePostsButton.disabled = false;
        });
    }



    jQuery(document).on('click', '.xbtn-loadmore', function(e) {
        e.preventDefault();
        let base = loadMorePostsButton.dataset.base;
        const pos = base.indexOf('?');
        
        console.log('base', base);
        console.log('pos', pos);

        let qs = '';

        // var btn = jQuery(this),
        //     base = btn.data('base'),
        //     pos = base.indexOf('?'),
        //     qs = '';

        if (pos > 0) {
            qs = base.substring(pos);
            base = base.substring(0, pos);
        }

        const buttonText = loadMorePostsButton.innerText;

        // if (typeof loadMoreButton.dataset.default === 'undefined') {
        //     loadMoreButton.dataset.default = loadMoreButton.innerText;
        // }

        jQuery.ajax({
            url: bf_opts.ajaxurl,
            type: 'post',
            data: {
                action: 'loadmore',
                query: bf_opts.posts,
                page: bf_opts.current_page,
                is_search: bf_opts.is_search,
            },
            beforeSend: function(xhr) {
                //btn.html('<span class="loadmore-spinner spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> Loading...');
                loadMoreButton.innerHTML = '<span class="loadmore-spinner spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> Loading...';
                loadMoreButton.disabled = true;
            },
            success: function success(result) {
                if (result) {
                    console.log('typeof result', typeof result);
                    console.log('result', result);

                    history.pushState('data', '', loadMoreButton.getAttribute('href'));
                    loadMoreButton.innerText = buttonText;

                    //var scroll = jQuery(window).scrollTop();

                    const postItems = document.querySelectorAll('.post-item');
                    const lastPost = postItems[postItems.length - 1]
                    console.log('lastPost', lastPost);

                    const resultHtml = document.createElement('div');

                    // jQuery('.post-item:last').after(result);

                    // jQuery(window).scrollTop(scroll);

                    lastPost.after(result);
                    
                    const postsTop = getElementTop(lastPost.parentElement);
                    if (postsTop !== false) {
                        window.scrollTo({
                            top: postsTop,
                            behavior: 'smooth'
                        });
                    }

                    bf_opts.current_page++;
                    
                    // btn.prop('href', base + 'page/' + (bf_opts.current_page + 1) + '/' + qs);

                    loadMoreButton.setAttribute('href', base + 'page/' + (bf_opts.current_page + 1) + '/' + qs);

                    if (bf_opts.current_page >= bf_opts.max_page) {
                        loadMoreButton.remove();
                    }
                } else {
                    loadMoreButton.remove();
                }
            },
        });
    });
}

export default LoadMore;
